import { useCampaignAgentListControllerListQuery } from '@shared/services/apiService/apiService';

export const useCampaignAgents = (campaignId: string | undefined, skip?: boolean) => {
  return useCampaignAgentListControllerListQuery(
    { id: campaignId || '' },
    {
      skip: skip || !campaignId,
      refetchOnMountOrArgChange: true,
    },
  );
};
